import { FC } from "react";
import { IStudent } from "../../../models/students.model";
import StudentName from "./Name";
import StudentPoint from "./Point";

interface IProps {
  student: IStudent|undefined;
}

const PointContainer: FC<IProps> = ({
  student,
}) => {
  return (
    <>
      <StudentName student={student} />
      <div className="mt-3" />
      <StudentPoint memberCode={student?.studentCode} />
    </>
  );
}

export default PointContainer;
